















import { Vue, Component } from 'vue-property-decorator';

import { getAppleAuth, ignoredAppleErrors, loadAppleID } from '~/plugins/social/apple';

@Component
export default class AppleLoginButton extends Vue {
  /*
    Triggers the Apple utils to open popup and start apple sign in process
    Will trigger this.onAppleResponse when apple provides user infos
  */
  async appleConnect () {
    try {
      await loadAppleID(this.$config.APPLE_APP_ID);
      const auth = await getAppleAuth();
      this.$social.rememberProvider("apple");
      this.onAppleResponse(auth);
    } catch (e) {
      if (!ignoredAppleErrors.has(e.error)) {
        this.$emit("error", e.error ?? e);
      }
    }
  }

  /* Handle the apple response and connect user with informations provided */
  async onAppleResponse (response: Types.AppleResponse) {
    const signInPayload: Types.SignInSocialPayload = {
      provider: "apple",
      body: {
        social_token: response.authorization.id_token || "",
        social_user_id: "",
      },
    };
    const apiError = await this.$store.dispatch('user/signinWithSocial', signInPayload);
    if (!apiError) {
      // The API call has suceeded, which means the user was already known and
      // is now authenticated. Skip the signup entirely.
      return this.$emit("signed-in");
    }

    // Retrieve user's info from apple and store them for next step
    const appleProfile = response.authorization.user;

    const userInfo: Types.SocialUserInfo = {
      provider: "apple",
      ...signInPayload.body,
      email: appleProfile?.email || "",
      firstname: appleProfile?.name.firstName || "",
      lastname: appleProfile?.name.lastName || "",
    };

    return this.$emit("need-signup", userInfo);
  }
}
